/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
/* eslint-disable import/prefer-default-export */
import wrapWithTheme from './src/wrapWithTheme';

export const wrapPageElement = wrapWithTheme;
